import { useState, useEffect, useRef } from 'react';
import '../Styles/ourpartner.css';

const institutionLogos = [
  {
    src: '/assets/New_prince_Logo.png',
    alt: 'New Prince',
    className: 'logo-new-prince',
  },

  {
    src: '/assets/Excel_logo.png',
    alt: 'Excel',
    className: 'logo-excel',
  },

  {
    src: '/assets/Peri_logo.png',
    alt: 'PERI',
    className: 'logo-peri',
  },
  {
    src: '/assets/Kalasalingam_logo.png',
    alt: 'Kalasalingam',
    className: 'logo-kalasalingam',
  },
];

const corporateLogos = [
  {
    src: '/assets/Inypeople_logo.png',
    alt: 'Inypeople',
    className: 'logo-inypeople',
  },
  {
    src: '/assets/Touch,ark_logo.png',
    alt: 'Touchmark',
    className: 'logo-touchmark',
  },
];

const initialFormState = {
  companyName: '',
  contactName: '',
  contactNumber: '',
  officialEmail: '',
  websiteLink: '',
  companyOverview: '',
  consent: false,
};

// ---------- Validation ----------
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Accepts digits, spaces, dashes, parentheses, optional leading +,
// requires 7-20 characters total (E.164-ish, loose on purpose).
const PHONE_PATTERN = /^\+?[0-9\s\-()]{7,20}$/;
const URL_PATTERN = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i;

function validateForm(data) {
  const errors = {};

  if (!data.companyName.trim()) {
    errors.companyName = 'Company name is required.';
  } else if (data.companyName.trim().length < 2) {
    errors.companyName = 'Company name looks too short.';
  }

  if (!data.contactName.trim()) {
    errors.contactName = 'Contact name is required.';
  } else if (data.contactName.trim().length < 2) {
    errors.contactName = 'Contact name looks too short.';
  }

  if (!data.contactNumber.trim()) {
    errors.contactNumber = 'Contact number is required.';
  } else if (!PHONE_PATTERN.test(data.contactNumber.trim())) {
    errors.contactNumber = 'Enter a valid contact number.';
  }

  if (!data.officialEmail.trim()) {
  errors.officialEmail = 'Official email is required.';
} else if (!EMAIL_PATTERN.test(data.officialEmail.trim())) {
  errors.officialEmail = 'Enter a valid email address.';
}
  if (!data.websiteLink.trim()) {
    errors.websiteLink = 'Website link is required.';
  } else if (!URL_PATTERN.test(data.websiteLink.trim())) {
    errors.websiteLink = 'Enter a valid website URL.';
  }

  if (!data.consent) {
    errors.consent = 'Please agree before submitting.';
  }

  return errors;
}

function OurPartners() {
  const [isCollabModalOpen, setIsCollabModalOpen] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const overlayRef = useRef(null);

  const openModal = () => setIsCollabModalOpen(true);

  const closeModal = () => {
    setIsCollabModalOpen(false);
    setFormData(initialFormState);
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const nextValue = type === 'checkbox' ? checked : value;

    setFormData((prev) => ({ ...prev, [name]: nextValue }));

    // Clear that field's error as soon as the user edits it.
    setErrors((prev) => {
      if (!prev[name]) return prev;
      const next = { ...prev };
      delete next[name];
      return next;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    // TODO: wire this up to your backend / email service once ready.
    console.log('Collaborate form submitted:', formData);
    closeModal();
  };

  // Escape to close + lock page scroll while modal is open
  useEffect(() => {
    if (!isCollabModalOpen) return;

    const handleEscape = (e) => {
      if (e.key === 'Escape') closeModal();
    };

    document.addEventListener('keydown', handleEscape);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = previousOverflow;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCollabModalOpen]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) closeModal();
  };

  return (
    <>
      {/* ===== SECTION 1 ===== */}
      <section className="partners-hero">
        <div className="partners-hero-content">
          <h1 className="partners-heading">
            Can you provide me with{' '}
            <span className="partners-highlight">
              some details about your company
            </span>
            , such as what it does, its mission, and any unique aspects?
          </h1>

          <button className="partners-btn" onClick={openModal}>
            Let's Collaborate
            <img
              src="/assets/home_arrow_icon.png"
              alt="Arrow"
              className="partners-arrow-icon"
            />
          </button>
        </div>
      </section>

      {/* ===== SECTION 2 ===== */}
      <section className="institution-section">
        <h2 className="partners-section-heading">Institution Partners</h2>
        <div className="partners-underline"></div>

        <div className="institution-logos-row">
          {institutionLogos.map((logo, index) => (
            <div className="institution-logo-item" key={index}>
              <img
                src={logo.src}
                alt={logo.alt}
                className={`institution-logo-img ${logo.className}`}
              />
            </div>
          ))}
        </div>

        {/* ===== SECTION 3 ===== */}
        <h2 className="partners-section-heading corporate-heading">
          Corporate Partners
        </h2>

        <div className="partners-underline"></div>

        <div className="corporate-logos-row">
          {corporateLogos.map((logo, index) => (
            <div className="corporate-logo-item" key={index}>
              <img
                src={logo.src}
                alt={logo.alt}
                className={`corporate-logo-img ${logo.className}`}
              />
            </div>
          ))}
        </div>
      </section>

      {/* ===== COLLABORATE FORM MODAL ===== */}
      {isCollabModalOpen && (
        <div
          className="collab-modal-overlay"
          ref={overlayRef}
          onMouseDown={handleOverlayClick}
        >
          <div
            className="collab-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="collab-modal-title"
          >
            <button
              type="button"
              className="collab-modal-close"
              onClick={closeModal}
              aria-label="Close form"
            >
              &times;
            </button>

            <div className="collab-modal-logo">
  <h2 className="collab-modal-title">Let's Partner Together</h2>
</div>

            <h2 id="collab-modal-title" className="collab-modal-heading-sr">
              Tell us about your company
            </h2>

            <form className="collab-form" onSubmit={handleSubmit} noValidate>
              <div className="collab-field">
                <label htmlFor="companyName">
                  Company Name<span className="collab-required">*</span>
                </label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  placeholder="Company Name"
                  value={formData.companyName}
                  onChange={handleChange}
                  className={errors.companyName ? 'collab-input-error' : ''}
                  aria-invalid={!!errors.companyName}
                />
                {errors.companyName && (
                  <span className="collab-error-msg">{errors.companyName}</span>
                )}
              </div>

              <div className="collab-field-row">
                <div className="collab-field">
                  <label htmlFor="contactName">
                    Contact Name<span className="collab-required">*</span>
                  </label>
                  <input
                    type="text"
                    id="contactName"
                    name="contactName"
                    placeholder="Contact Name"
                    value={formData.contactName}
                    onChange={handleChange}
                    className={errors.contactName ? 'collab-input-error' : ''}
                    aria-invalid={!!errors.contactName}
                  />
                  {errors.contactName && (
                    <span className="collab-error-msg">
                      {errors.contactName}
                    </span>
                  )}
                </div>

                <div className="collab-field">
                  <label htmlFor="contactNumber">
                    Contact Number<span className="collab-required">*</span>
                  </label>
                  <input
                    type="tel"
                    id="contactNumber"
                    name="contactNumber"
                    placeholder="Contact Number"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    className={
                      errors.contactNumber ? 'collab-input-error' : ''
                    }
                    aria-invalid={!!errors.contactNumber}
                  />
                  {errors.contactNumber && (
                    <span className="collab-error-msg">
                      {errors.contactNumber}
                    </span>
                  )}
                </div>
              </div>

              <div className="collab-field">
               <label htmlFor="officialEmail">
  Official Email<span className="collab-required">*</span>
</label>
               <input
  type="email"
  id="officialEmail"
  name="officialEmail"
  placeholder="Official Email"
  value={formData.officialEmail}
  onChange={handleChange}
  className={errors.officialEmail ? 'collab-input-error' : ''}
  aria-invalid={!!errors.officialEmail}
/>
                {errors.officialEmail && (
  <span className="collab-error-msg">
    {errors.officialEmail}
  </span>
)}
              </div>

              <div className="collab-field">
                <label htmlFor="websiteLink">
                  Website Link<span className="collab-required">*</span>
                </label>
                <input
                  type="text"
                  id="websiteLink"
                  name="websiteLink"
                  placeholder="Paste Website link"
                  value={formData.websiteLink}
                  onChange={handleChange}
                  className={errors.websiteLink ? 'collab-input-error' : ''}
                  aria-invalid={!!errors.websiteLink}
                />
                {errors.websiteLink && (
                  <span className="collab-error-msg">
                    {errors.websiteLink}
                  </span>
                )}
              </div>

              <div className="collab-field">
                <label htmlFor="companyOverview">Company Overview</label>
                <textarea
                  id="companyOverview"
                  name="companyOverview"
                  placeholder="Company Overview"
                  rows={4}
                  value={formData.companyOverview}
                  onChange={handleChange}
                />
              </div>

              <div className="collab-consent">
                <input
                  type="checkbox"
                  id="consent"
                  name="consent"
                  checked={formData.consent}
                  onChange={handleChange}
                  aria-label="I agree that Vanakkam HRD may contact me"
                />
                <span className="collab-consent-text">
                  By checking this box, you agree that vanakkam HRD may
                  contact you to provide you with more information about
                  their products, events and offers, you can unsubscribe at
                  any time.

                </span>
              </div>
              {errors.consent && (
                <span className="collab-error-msg collab-consent-error">
                  {errors.consent}
                </span>
              )}

              <button type="submit" className="collab-submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default OurPartners;
